module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/23-9207828c531751363859ac53378efdac.png";